import { transformRoutes } from '@backoffice-frontend/common'

export const BaseRiderFeedbackAreaRoutes = {
  route: '/rider-feedback',
  Safety: {
    route: '/safety',
  },
}

export const RiderFeedbackAreaRoutes = transformRoutes(
  BaseRiderFeedbackAreaRoutes,
)
